/**
 * Location hierarchy.
 *
 * Modelled as a FLEXIBLE TREE, not as a fixed chain
 * `Site -> Building -> Floor -> Room`. Reason (see
 * docs/reference-document-analysis.md, section 3): the reference documentation
 * contains
 * - objects attached directly to a floor without any area,
 * - buildings whose only level is "ground floor",
 * - and a linear utility tunnel that crosses building boundaries and has its
 *   own segments - it is not a building, not a floor, and not a room.
 *
 * A rigid chain cannot express that. A typed tree can, and it stays validatable
 * because `locationType` is a closed list.
 */
export const LOCATION_TYPES = [
    /** Site / premises. Usually the root node of a customer. */
    'site',
    'building',
    'floor',
    /** Named area inside a floor or building without being a closed room. */
    'area',
    'room',
    /** Linear structure such as a utility tunnel or a cable route segment. */
    'section',
    /** Outdoor area belonging to the site. */
    'outdoor',
];
export const LOCATION_STATUSES = ['active', 'planned', 'inactive'];
/**
 * Display label of a single node: `code` and `name` combined, whichever exists.
 * Never store the result - it is derived and would drift.
 */
export function locationLabel(node) {
    if (node.code && node.name) {
        return `${node.code} | ${node.name}`;
    }
    return node.code ?? node.name ?? '';
}
/**
 * Breadcrumb label for a node, built from its ancestors.
 * `ancestors` must be ordered root-first and include the node itself.
 */
export function locationPathLabel(ancestors, separator = ' | ') {
    return ancestors
        .map((node) => locationLabel(node))
        .filter((label) => label.length > 0)
        .join(separator);
}
/** Type guard used by repositories to keep narrowed reads honest. */
export function isLocationType(node, locationType) {
    return node.locationType === locationType;
}
//# sourceMappingURL=location.js.map